import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL brands -------------------- */
export const AllBrandsThunk = createAsyncThunk(
  "brands/AllBrandsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/brands/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch brands");
    }
  }
);

/* -------------------- GET SINGLE brands -------------------- */
export const GetSingleBrandsThunk = createAsyncThunk(
  "brands/GetSingleBrandsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/brands/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch brands details"
      );
    }
  }
);

/* -------------------- ADD brands -------------------- */
export const AddBrandsThunk = createAsyncThunk(
  "brands/AddBrandsThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/brands/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add brands");
    }
  }
);

/* -------------------- UPDATE brands -------------------- */
export const UpdateBrandsThunk = createAsyncThunk(
  "brands/UpdateBrandsThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/brands/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update brands");
    }
  }
);

/* -------------------- DELETE brands -------------------- */
export const DeleteBrandsThunk = createAsyncThunk(
  "brands/DeleteBrandsThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/brands/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete brands");
    }
  }
);
